import React, { useState, useEffect, useRef } from 'react';

import { connect } from 'umi';

import { Icon } from 'tea-component';

export default connect()(function LoadState(props) {
  const {
    height,
    icon,
    title = 'Loading...',
    justify = 'center',
    marginleft = 0,
  } = props;

  return (
    <div
      style={{
        width: '100%',
        height: height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: justify,
        marginLeft: marginleft,
        zIndex: 10000,
      }}
    >
      {icon ? <Icon size="l" type={icon} /> : null}
      &nbsp;&nbsp;&nbsp;{title}
    </div>
  );
});
